import { convertToCurrency } from "../utility/utility.js";
import { convertRuntime } from "../utility/utility.js";

import {
  api_key,
  root_endpoint,
  sampleId,
  sampleName,
  getDb,
  pathEndpoints,
  getGenreList,
  getConfig,
} from "./apiSetUp.js";

export async function get_movie_info(movieId, type_of_info) {
  const additional_endpoints =
    type_of_info === "getMovieDetails" || type_of_info === "getTvDetails"
      ? "&append_to_response=releases,credits,images,videos,keywords,recommendations"
      : "";
  const endpoints =
    root_endpoint +
    pathEndpoints[type_of_info].replace("{movie_id}", `${movieId}`) +
    api_key +
    additional_endpoints;
  const data = await getDb(endpoints);
  return data;
}

export async function get_detail(id, type) {
  let typeList = type == "mov" ? "getMovieDetails" : "getTvDetails";
  const detailData = await get_movie_info(id, typeList);
  /*const configLanguageData = await getConfig("getConfigLanguage");
  const configCountryData = await getConfig("getConfigCountry");
  const movGenreData = await getGenreList("getMovieGenreList");
  const tvGenreData = await getGenreList("getTVGenreList");

  const creditData = detailData.credits;
  const imageData = detailData.images;
  const videoData = detailData.videos;
  const rcmData = detailData.recommendations;

  return {
    id: movieId,
    name: detailData.title,
    poster_path: detailData.poster_path ? "https://www.themoviedb.org/t/p/original" + detailData.poster_path : noImageImg,
    release_date: detailData.release_date.match(/\d{4}/g)[0],
    short_country: detailData.production_countries.map(
      (country) => configCountryData[country.name]
    ),
    country: detailData.production_countries.map((country) => country.name),
    runtime: convertRuntime(detailData.runtime),
    overview: detailData.overview,
    collection: detailData.belongs_to_collection,
    director: creditData.crew
      .filter((p) => p.job == "Director")
      .map((dir) => {
        return {
          name: dir.name,
          id: dir.id,
          profile_path: dir.profile_path,
        };
      }),
    cast: creditData.cast.map((p) => {
      return {
        name: p.name,
        character: p.character,
        id: p.id,
        profile_path: p.profile_path,
      };
    }),
    others: {
      genres: detailData.genres.map((item) => item.name).join(", "),
      budget: convertToCurrency(detailData.budget),
      revenue: convertToCurrency(detailData.revenue),
      original_language: configLanguageData[detailData.original_language],
      original_title: detailData.original_title,
      status: detailData.status,
    },
    tagline: detailData.tagline,
    backdrops: imageData.backdrops,
    videos: videoData.results,
    certification:
      detailData.releases.countries.filter((item) =>
        Object.values(item).includes("US")
      ).length !== 0
        ? detailData.releases.countries.filter((item) =>
            Object.values(item).includes("US")
          )
        : [{ certification: "NoCert" }],
    //rcm: rcmData.results.map((item) => item.id),
    recommendation: rcmData.results.map((item) => {
      return {
        ...item,
        configLanguageData: configLanguageData,
        configCountryData: configCountryData,
        movGenreData: movGenreData,
        tvGenreData: tvGenreData,
      };
    }),
  };*/

  return detailData;
}

async function get_movie_rcm(movideId) {
  const rcmData = await get_movie_info(movideId, "getMovieRcm");
}

async function get_movie_other_info(movieId) {
  //Other Info: Videos, Keywords, Providers, Images
  const keywordData = get_movie_info(movieId, "getMovieKeywords");
  const providerData = get_movie_info(movieId, "getMovieWatchProviders");
}

async function test_get_movie_info(movieId, type_of_info) {
  const test_data = await get_movie_info(movieId, type_of_info);
  //other test below
  console.log(test_data);
  console.log(Object.keys(test_data));
}

//test_get_movie_info(sampleId, "getMovieDetails");

async function test_get_detail(movideId, type) {
  const test_data = await get_detail(movideId, type);
  console.log(test_data);
  console.log(Object.keys(test_data));
  //console.log(test_data.results)
  //Test below
  //console.log(test_data.recommendation)
}

//test_get_detail(506281, "mov");

export default test_get_movie_info;
